import { ng } from '@uirouter/angularjs/lib/angular';
import angular = require('angular');
import { IProductVariationIngredient } from '../../../../../model/products/IProductVariationIngredient';

class ProductVariationIngredient implements ng.IController {

    public static $inject = [
        '$scope',
        '$interpolate'
    ];

    public item: IProductVariationIngredient;
    public onIngredientChanged: (item: any) => any;
    public minQuantity: number;
    public isTakeAwayPriceDisabled: boolean;
    public isEatInPriceDisabled: boolean;

    public form: ng.IFormController & {
        price: ng.INgModelController,
        insidePrice: ng.INgModelController,
        defaultQuantity: ng.INgModelController,
        maxQuantity: ng.INgModelController
    };

    public priceErrorList: {[id: string]: string} = {
        number: 'variation_ingredient_takeaway_price_required_error',
        parse: 'variation_ingredient_default_quantity_required_error',
        required: 'variation_ingredient_default_quantity_required_error',
        priceMustBeLessOrEqualInsidePriceModel: 'variation_ingredient_takeaway_price_less_eat_in_price_error'
    };

    public insidePriceErrorList: {[id: string]: string} = {
        number: 'variation_ingredient_takeaway_price_required_error',
        parse: 'variation_ingredient_default_quantity_required_error',
        required: 'variation_ingredient_default_quantity_required_error',
        insidePriceMustBeGreaterOrEqualPriceModel: 'variation_ingredient_takeaway_price_greater_eat_in_price_error'
    };

    public defaultQuantityErrorList: {[id: string]: string} = {
        required: 'variation_ingredient_default_quantity_required_error',
        parse: 'variation_ingredient_default_quantity_required_error',
        number: 'variation_ingredient_default_quantity_required_error',
        defaultQuantityMustBeGreaterMinQuantityModel: 'variation_ingredient_default_quantity_greater_min_error',
        defaultQuantityMustBeLessMaxQuantityModel: 'variation_ingredient_default_quantity_less_max_error'
    };

    public maxQuantityErrorList: {[id: string]: string} = {
        required: 'variation_ingredient_max_quantity_required_error',
        parse: 'variation_ingredient_max_quantity_required_error',
        number: 'variation_ingredient_max_quantity_required_error',
        maxQuantityMustBeGreaterDefaultQuantityModel: 'variation_ingredient_max_quantity_greater_default_error',
        maxQuantityMustBeGreaterMinQuantityModel: 'variation_ingredient_max_quantity_greater_min_error'
    };

    public isError: boolean = true;

    constructor(
        private $scope: angular.IScope,
        private $interpolate: angular.IInterpolateService
    ) {
    }

    public $onInit() {
        this.$scope.$watch('ctrl.minQuantity', (n: any, o: any) => {
            if (n != null) {
                this.validateFields();
            }
        });
    }

    public $postLink(): void {
        this.form.defaultQuantity.$validators.defaultQuantityMustBeGreaterMinQuantityModel = this.defaultQuantityMustBeGreaterMinQuantity.bind(this);
        this.form.defaultQuantity.$validators.defaultQuantityMustBeLessMaxQuantityModel = this.defaultQuantityMustBeLessMaxQuantity.bind(this);
        this.form.maxQuantity.$validators.maxQuantityMustBeGreaterDefaultQuantityModel = this.maxQuantityMustBeGreaterDefaultQuantity.bind(this);
        this.form.maxQuantity.$validators.maxQuantityMustBeGreaterMinQuantityModel = this.maxQuantityMustBeGreaterMinQuantity.bind(this);
        this.form.insidePrice.$validators.insidePriceMustBeGreaterOrEqualPriceModel = this.insidePriceMustBeGreaterOrEqualPriceModel.bind(this);
        this.form.price.$validators.priceMustBeLessOrEqualInsidePriceModel = this.priceMustBeLessOrEqualInsidePriceModel.bind(this);
    }

    public getPriceErrorText() {
        const errorKeys = Object.keys(this.form.price.$error).map((key) => this.priceErrorList[key]);
        return this.getErrorString(errorKeys);
    }

    public getInsidePriceErrorText() {
        const errorKeys = Object.keys(this.form.insidePrice.$error).map((key) => this.insidePriceErrorList[key]);
        return this.getErrorString(errorKeys);
    }

    public getDefaultQuantityErrorText() {
        const errorKeys = Object.keys(this.form.defaultQuantity.$error).map((key) => this.defaultQuantityErrorList[key]);
        return this.getErrorString(errorKeys);
    }

    public getMaxQuantityErrorText() {
        const errorKeys = Object.keys(this.form.maxQuantity.$error).map((key) => this.maxQuantityErrorList[key]);
        return this.getErrorString(errorKeys);
    }

    public validateFields() {
        if (this.onIngredientChanged) {
            this.onIngredientChanged({item: this.item});
        }
        this.form.price.$validate();
        this.form.insidePrice.$validate();
        this.form.defaultQuantity.$validate();
        this.form.maxQuantity.$validate();
    }

    private getErrorString(errorKeys: string[]) {
        const template = '{{ error | translate}}';
        const exp = this.$interpolate(template);
        let resultError = '';
        errorKeys.forEach((key) => {
            resultError += '<i class="fa fa-exclamation-circle mr3"></i>' + exp({ error: key}) + '<br>';
        });
        return resultError;
    }

    private defaultQuantityMustBeGreaterMinQuantity(defaultQuantity: number) {
        if (this.minQuantity === null || this.minQuantity === undefined) { return false; }
        return defaultQuantity >= this.minQuantity;
    }

    private defaultQuantityMustBeLessMaxQuantity(defaultQuantity: number) {
        if (this.minQuantity === null || this.minQuantity === undefined) { return false; }
        return defaultQuantity <= this.item.MaxQuantity;
    }

    private maxQuantityMustBeGreaterDefaultQuantity(maxQuantity: number) {
        if (this.minQuantity === null || this.minQuantity === undefined) { return false; }
        return maxQuantity >= this.item.DefaultQuantity;
    }

    private maxQuantityMustBeGreaterMinQuantity(maxQuantity: number) {
        if (this.minQuantity === null || this.minQuantity === undefined) { return false; }
        return maxQuantity >= this.minQuantity;
    }

    private insidePriceMustBeGreaterOrEqualPriceModel(insidePrice: number) {
        const isTakeawayPriceNotAvailable = this.item.Price === null || this.item.Price === undefined ||
            Number.isNaN(this.item.Price) || this.isTakeAwayPriceDisabled;
        if (isTakeawayPriceNotAvailable) { return true; }

        const isEatInPriceNotAvailable = insidePrice === null || insidePrice === undefined ||
            Number.isNaN(insidePrice) || this.isEatInPriceDisabled;
        if (isEatInPriceNotAvailable) { return true; }

        return insidePrice >= this.item.Price;
    }

    private priceMustBeLessOrEqualInsidePriceModel(price: number) {
        const isTakeawayPriceNotAvailable = price === null || price === undefined || Number.isNaN(price) ||
            this.isTakeAwayPriceDisabled;
        if (isTakeawayPriceNotAvailable) { return true; }

        const isEatInPriceNotAvailable = this.item.InsidePrice === null || this.item.InsidePrice === undefined ||
            Number.isNaN(this.item.InsidePrice) || this.isEatInPriceDisabled;
        if (isEatInPriceNotAvailable) { return true; }

        return price <= this.item.InsidePrice;
    }

}

angular.module('naut').component('productVariationIngredient', {
    template: require('./product-variation-ingredient.component.html'),
    controller: ProductVariationIngredient,
    controllerAs: 'ctrl',
    bindings: {
        item: '=',
        minQuantity: '<',
        onIngredientChanged: '&?',
        isTakeAwayPriceDisabled: '<',
        isEatInPriceDisabled: '<',
        currencyClass: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/shared/product-variation-ingredients-list/product-variation-ingredient/product-variation-ingredient.component.ts